import styled from 'styled-components';

const MyDiv = styled.div`
  .slider-box {
    border-radius: 4px;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.06);
    padding: 8px 8px 8px 8px;
    align-items: center;
  }

.slider-card {
  background: #fff;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 10px;
  flex: 1;
  position: relative;
  height: 250px;   
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: auto;  
}
.slider-card::-webkit-scrollbar {
  width: 6px;
}

.slider-card::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.slider-card::-webkit-scrollbar-thumb:hover {
  background: #999;
}


  .slider-dots {
   
    bottom: 16px;
    right: 16px;
  }

  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #ccc;
    transition: background 0.3s ease;
  }

  .dot.active {
    background: #333;
  }
`;

export default MyDiv;
